export interface Conversation {
  id: string
  createdAt: Date
  updatedAt: Date
  userId: string
  userName?: string | null
  agentId: string
  creatorId: string | null
  userPhotoUrl?: string | null
  userEmail?: string | null
  endedAt: Date | null
  startedAt: Date
  rating: number | null
  feedback: string | null
  feedbackTopic: string | null
  leftAt: Date | null
  sendTranscriptToUser?: boolean | null
}

export enum ConversationStatus {
  Completed = "Completed",
  Live = "Live",
  UserLeft = "User Left",
}
